import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';

// ============================================================
// ProtectedRoute
// Wraps any route that needs authentication + role check
//
// Usage:
//   <ProtectedRoute roles={['admin']}>
//     <AdminDashboard />
//   </ProtectedRoute>
// ============================================================

export default function ProtectedRoute({ children, roles = [] }) {
    const { user, token, loading } = useAuth();

    // Still loading from localStorage — show spinner
    if (loading) return <LoadingSpinner />;

    // Not logged in → go to login
    if (!token || !user) return <Navigate to="/login" replace />;

    // Wrong role → go to their home
    if (roles.length > 0 && !roles.includes(user.role)) {
        const redirects = {
            admin:    '/admin/offres',
            director: '/director/offres',
            trainer:  '/trainer/candidatures',
        };
        return <Navigate to={redirects[user.role] || '/'} replace />;
    }

    return children;
}
